<template>
  <hb-basic-page :fill-height="true" :loading="loading">
    <v-col class="pa-0 fill-height" cols="12">
      <v-row align="center" class="fill-height" no-gutters>
        <v-container fluid pa-0>
          <v-row no-gutters>
            <v-col cols="12">
              <v-row align="center" justify="center" no-gutters>
                <div class="text-center px-5 pb-8 pb-md-16">
                  <div class="image-holder">
                    <div class="grey lighten-5 rounded-circle" style="width: 100%; height: 100%;">
                      <v-slide-x-transition>
                        <v-row v-if="imageIsLoaded" align="center" class="fill-height" justify="center" no-gutters>
                          <img src="img/undraw_page_not_found_re_e9o6.svg" style="height: 80%;"/>
                        </v-row>
                      </v-slide-x-transition>
                    </div>
                  </div>
                  <div :class="$vuetify.breakpoint.xsOnly ? 'title' : 'headline'" class="font-weight-bold mt-5 mb-5">
                    {{ $t('page_not_found.title') }}
                  </div>
                  <div :class="$vuetify.breakpoint.xsOnly ? 'subtitle-2' : 'subtitle-1'">
                    {{ $t('page_not_found.text') }}
                  </div>
                  <div>
                    <v-btn class="mt-5" color="primary" @click="goBack">
                      <v-icon left>mdi mdi-arrow-left</v-icon>
                      {{ $t('access_denied.back') }}
                    </v-btn>
                  </div>
                </div>
              </v-row>
            </v-col>
          </v-row>

          <img src="img/undraw_page_not_found_re_e9o6.svg" style="display: none;" @load="imageIsLoaded = true"/>

        </v-container>
      </v-row>
    </v-col>
  </hb-basic-page>
</template>

<script>
export default {
  name: "PageNotFound",
  data() {
    return {
      loading: true,
      imageIsLoaded: false,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
.image-holder {
  position: relative;
  margin: auto;
  width: 45vw;
  height: 45vw;
}

@media screen and (min-width: 600px) {
  .image-holder {
    width: 15vw;
    height: 15vw;
  }
}
</style>
